<template>
    <section
        :data-mui-theme="theme"
        class="slice slice-content-columns slice-content-columns--grid"
        aria-label="content-columns"
        data-testid="slice-content-columns-grid"
    >
        <div class="slice-content">
            <PrismicRichText v-if="isFilled.richText(slice.primary.title)" :field="slice.primary.title" class="slice-title" />
            <PrismicRichText v-if="isFilled.richText(slice.primary.description)" :field="slice.primary.description" class="slice-description" />
            <ContentColumsLine
                v-for="(line, index) in lines"
                :key="`columns-grid-line--${index}`"
                :columns="line.columns"
                :index="index"
                class="slice-body"
                :class="hasMultipleLines ? 'slice-content-columns-line--with-multiple-lines' : ''"
            />
        </div>
    </section>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {isFilled} from '@prismicio/helpers';
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {ContentColumnsSlice} from '@prismicio-types';
    import ContentColumsLine from '../components/ContentColumsLine.vue';

    type ContentColumnsGridInZone = Extract<ContentColumnsSlice, {variation: 'contentColumnsGrid'}>;

    const props = defineProps(getSliceComponentProps<ContentColumnsGridInZone>());

    const theme = computed(() => props.slice.primary.theme);
    const lines = computed(() => [
        {
            columns: props.slice.primary.columnsLine1 ?? [],
        },
        {
            columns: props.slice.primary.columnsLine2 ?? [],
        },
    ]);
    const hasMultipleLines = computed(() => lines.value.length > 1 && lines.value.every((line) => line.columns.length > 0));
</script>
